import { c as _c } from "react/compiler-runtime";
import { Autocomplete } from '@base-ui/react/autocomplete';
import type { SearchItem, SearchResultItem, SearchResultSource } from '../../../search.types';
import { SearchResultAssistButton } from './search-result-assist-button';
import { SearchResultLink } from './search-result-link';
const GROUP_LABELS: Record<SearchItem['kind'], string> = {
  recent: 'Recent searches',
  query: 'Popular searches',
  product: 'Product results'
};
type SearchResultGroupProps = {
  onResult: (result: SearchResultItem) => void;
  query: string;
  source: SearchResultSource;
};
export function SearchResultGroup(t0) {
  const $ = _c(13);
  const {
    onResult,
    query,
    source
  } = t0;
  const label = source.kind === "query" && query !== "" ? "" : GROUP_LABELS[source.kind];
  const t1 = source.items;
  let t2;
  if ($[0] !== label) {
    t2 = label && <Autocomplete.Row className="header-search__group-label-row"><Autocomplete.GroupLabel className="header-search__group-label" role="gridcell">{label}</Autocomplete.GroupLabel></Autocomplete.Row>;
    $[0] = label;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onResult || $[3] !== query || $[4] !== source.rows) {
    let t4;
    if ($[6] !== onResult || $[7] !== query) {
      t4 = row => <Autocomplete.Row key={row.primary.id} className="header-search__row"><SearchResultLink onResult={onResult} query={query} result={row.primary} />{row.assisted && <SearchResultAssistButton onResult={onResult} result={row.assisted} />}</Autocomplete.Row>;
      $[6] = onResult;
      $[7] = query;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = source.rows.map(t4);
    $[2] = onResult;
    $[3] = query;
    $[4] = source.rows;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[9] !== source.items || $[10] !== t2 || $[11] !== t3) {
    t4 = <Autocomplete.Group className="header-search__group" items={t1} role="rowgroup">{t2}{t3}</Autocomplete.Group>;
    $[9] = source.items;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}